<template>
  <div class="text-right mb-4">
  <v-dialog v-model="modifiersDialog"  max-width="608px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
              dark
              v-bind="attrs"
              v-on="on"
      >
        Редактировать
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Добавить модификатор</v-card-title>
      <v-card-text>
        <v-checkbox
                v-for="modifierGroup in modifiersGroup"
                :key="modifierGroup.id"
                v-model="modifierGroup.selected"
                :label="modifierGroup.name + '(' + modifierGroup.working_name + ')'"
        ></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-btn block @click="update" :loading="loadingButton">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
  import ModifierService from "../api/ModifierService";
  import ProductService from "../api/ProductService";
  import CategoryService from "../api/CategoryService";

  export default {
    name: 'ModifiersGroupModal',
    props: {
      value: Object,
      is_constructor: {
        default: false,
        type: Boolean
      }
    },
    components: {},
    data() {
      return {
        modifiersDialog: false,
        modifiersGroup: [],
        product: this.value,
        loadingButton: false,
      };
    },
    methods: {
      update() {
        var modifiersGroup = [];
        this.loadingButton = true

        this.modifiersGroup.forEach(function (modifierGroup) {
          if(modifierGroup.selected){
              modifiersGroup.push(modifierGroup.id)
          }
        })

        if(this.is_constructor){
          CategoryService.updateModifiersGroup(this.product.id, modifiersGroup).then(response => {
            this.product.modifiers_group = response.data.modifiers_group
            this.modifiersDialog = false;
            this.loadingButton = false
          });
        } else {
          ProductService.updateModifiersGroup(this.product.id, modifiersGroup).then(response => {
            this.product.modifiers_group = response.data.modifiers_group
            this.modifiersDialog = false;
            this.loadingButton = false
          });
        }

      }
    },
    mounted() {
        let _this = this;

        ModifierService.listGroups().then(response => {
            _this.modifiersGroup = response.data
            _this.modifiersGroup.forEach(function (modifierGroup) {
                if(_this.product.modifiers_group.find(group => group.id == modifierGroup.id)){
                    modifierGroup.selected = true
                }
            })
        });
    },
    watch: {
      product(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss">
  .without-border {
    .v-input__slot{
      padding: 0!important;
    }
    .v-icon{
      width: 40px;
    }
    .v-input__prepend-outer{
      margin-right: 0;
    }
    .theme--light.v-icon:focus::after {
      opacity: 0;
    }
    input{
      text-align: center;
    }
    &.v-text-field--outlined{
      fieldset {
        border: none!important;
      }
    }
  }
  .without-padding .v-expansion-panel-content__wrap{
    padding: 0;
  }

</style>

<style lang="scss" scoped>

  ul{
    list-style-type: none;
    padding-left: 0;
    li{
      list-style-type: none;
      display: grid;
      grid-template-columns: 98px 1fr;
      margin-bottom: 8px;
      &.selected{
        background-color: #EEF8FF;
      }
      .name{
        line-height: 40px;
        color: #666;
        font-weight: 500;
        padding-left: 8px;
        font-size: 14px;
      }
    }
  }

</style>
